import { ECurrency } from 'types/Enums'

export const CURRENCIES = Object.values(ECurrency)

export const CURRENCY_FLAGS: Record<ECurrency, string> = {
  [ECurrency.DKK]: '🇩🇰',
  [ECurrency.EUR]: '🇪🇺',
  [ECurrency.SEK]: '🇸🇪'
}
